export default function(smpte, framerate){

  if(!framerate){
    framerate = 24
  }

  let t = smpte.split(':')

  let h = t[0] * 1
  let m = t[1] * 1
  let s = t[2] * 1
  let f = t[3] * 1

  let seconds = h * 60 * 60 + m * 60 + s + f / 24

  return Math.round(seconds * 10) / 10

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/util/smpteToSeconds/smpteToSeconds.js